// IAM API layer for HMS-INTERNAL-BACKEND
import http from './http';

function handleError(error) {
  const msg = error?.response?.data?.message || error?.message || 'Request failed';
  throw new Error(msg);
}

// ===================
// PERMISSIONS API
// ===================

// GET /api/v1/iam/permissions
export async function getAllPermissions(query = {}) {
  try {
    const params = new URLSearchParams(query).toString();
    const url = `/api/v1/iam/permissions${params ? `?${params}` : ''}`;
    console.log('Permissions API URL:', url); // Debug log
    console.log('Permissions query params:', query); // Debug log
    const res = await http.get(url);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// POST /api/v1/iam/permissions
export async function createPermission(permissionData) {
  try {
    const res = await http.post('/api/v1/iam/permissions', permissionData);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// GET /api/v1/iam/permissions/:id
export async function getPermissionById(id) {
  try {
    const res = await http.get(`/api/v1/iam/permissions/${id}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// PUT /api/v1/iam/permissions/:id
export async function updatePermission(id, updateData) {
  try {
    const res = await http.put(`/api/v1/iam/permissions/${id}`, updateData);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// DELETE /api/v1/iam/permissions/:id
export async function deletePermission(id) {
  try {
    const res = await http.delete(`/api/v1/iam/permissions/${id}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// ===================
// POLICIES API
// ===================

// GET /api/v1/iam/policies
export async function getAllPolicies(query = {}) {
  try {
    const params = new URLSearchParams(query).toString();
    const url = `/api/v1/iam/policies${params ? `?${params}` : ''}`;
    const res = await http.get(url);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// POST /api/v1/iam/policies
export async function createPolicy(policyData) {
  try {
    const res = await http.post('/api/v1/iam/policies', policyData);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// GET /api/v1/iam/policies/:id
export async function getPolicyById(id) {
  try {
    const res = await http.get(`/api/v1/iam/policies/${id}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// PUT /api/v1/iam/policies/:id
export async function updatePolicy(id, updateData) {
  try {
    const res = await http.put(`/api/v1/iam/policies/${id}`, updateData);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// DELETE /api/v1/iam/policies/:id
export async function deletePolicy(id) {
  try {
    const res = await http.delete(`/api/v1/iam/policies/${id}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// ===================
// GROUPS API
// ===================

// GET /api/v1/iam/groups
export async function getAllGroups() {
  try {
    const res = await http.get('/api/v1/iam/groups');
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// POST /api/v1/iam/groups
export async function createGroup(groupData) {
  try {
    const res = await http.post('/api/v1/iam/groups', groupData);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// GET /api/v1/iam/groups/:id
export async function getGroupById(id) {
  try {
    const res = await http.get(`/api/v1/iam/groups/${id}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// PUT /api/v1/iam/groups/:id
export async function updateGroup(id, updateData) {
  try {
    const res = await http.put(`/api/v1/iam/groups/${id}`, updateData);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// DELETE /api/v1/iam/groups/:id
export async function deleteGroup(id) {
  try {
    const res = await http.delete(`/api/v1/iam/groups/${id}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// ===================
// USER-GROUP ATTACHMENTS
// ===================

// POST /api/v1/iam/groups/:id/users/:userId
export async function addUserToGroup(groupId, userId) {
  try {
    const res = await http.post(`/api/v1/iam/groups/${groupId}/users/${userId}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// DELETE /api/v1/iam/groups/:id/users/:userId
export async function removeUserFromGroup(groupId, userId) {
  try {
    const res = await http.delete(`/api/v1/iam/groups/${groupId}/users/${userId}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// ===================
// POLICY ATTACHMENTS
// ===================

// POST /api/v1/iam/users/:userId/policies/:policyId
export async function attachPolicyToUser(userId, policyId) {
  try {
    const res = await http.post(`/api/v1/iam/users/${userId}/policies/${policyId}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// DELETE /api/v1/iam/users/:userId/policies/:policyId
export async function detachPolicyFromUser(userId, policyId) {
  try {
    const res = await http.delete(`/api/v1/iam/users/${userId}/policies/${policyId}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// POST /api/v1/iam/groups/:groupId/policies/:policyId
export async function attachPolicyToGroup(groupId, policyId) {
  try {
    const res = await http.post(`/api/v1/iam/groups/${groupId}/policies/${policyId}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// DELETE /api/v1/iam/groups/:groupId/policies/:policyId
export async function detachPolicyFromGroup(groupId, policyId) {
  try {
    const res = await http.delete(`/api/v1/iam/groups/${groupId}/policies/${policyId}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// ===================
// UTILITY FUNCTIONS
// ===================

// GET /api/v1/iam/test
export async function testIamConnection() {
  try {
    const res = await http.get('/api/v1/iam/test');
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// GET /api/v1/iam/users/:userId/permissions
export async function getUserPermissions(userId) {
  try {
    const res = await http.get(`/api/v1/iam/users/${userId}/permissions`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// POST /api/v1/iam/simulate - Permission simulation
export async function simulatePermissions(simulationData) {
  try {
    const res = await http.post('/api/v1/iam/simulate', simulationData);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// Default export object with all IAM API functions
const iamAPI = {
  // Permissions
  getAllPermissions,
  createPermission,
  getPermissionById,
  updatePermission,
  deletePermission,
  
  // Policies
  getAllPolicies,
  createPolicy,
  getPolicyById,
  updatePolicy,
  deletePolicy,
  
  // Groups
  getAllGroups,
  createGroup,
  getGroupById,
  updateGroup,
  deleteGroup,
  
  // User-Group Attachments
  addUserToGroup,
  removeUserFromGroup,
  
  // Policy Attachments
  attachPolicyToUser,
  detachPolicyFromUser,
  attachPolicyToGroup,
  detachPolicyFromGroup,
  
  // Utility Functions
  testIamConnection,
  getUserPermissions,
  simulatePermissions
};

export default iamAPI;
